export const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: 'white'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1em',
    width: 'auto'
  },
  avatar: {
    margin: '1em',
    textAlign: 'center',
    width: 60,
    height: 60
  },
  button: {
    marginTop: '2em',
    textAlign: 'center'
  },
  link: {
    textDecoration: 'none',
    textTransform: 'none'
  }
}



// WEBPACK FOOTER //
// ./src/pages/BinLogin/styles.js